import type { MenuItem } from '@/systems/MenuNavigation';

/**
 * Returns the main-menu item list. Continue is enabled only when there is
 * an in-progress run with a chosen hero.
 */
export function buildMainMenuItems(hasSave: boolean): MenuItem[] {
  return [
    { id: 'start', label: 'START', enabled: true },
    { id: 'continue', label: 'CONTINUE', enabled: hasSave },
    { id: 'survival', label: 'SURVIVAL', enabled: true },
    { id: 'boss-rush', label: 'BOSS RUSH', enabled: true },
    { id: 'score-attack', label: 'SCORE ATTACK', enabled: true },
    { id: 'gallery', label: 'ENDINGS GALLERY', enabled: true },
    { id: 'coop', label: 'CO-OP', enabled: true }, // local 2-player co-op (CharSelect P1/P2 + P2_DEFAULTS input)
    { id: 'options', label: 'OPTIONS', enabled: true },
    { id: 'credits', label: 'CREDITS', enabled: true },
  ];
}

/** Pause overlay menu: Resume / Restart / Options / Quit. */
export function buildPauseMenuItems(): MenuItem[] {
  return [
    { id: 'resume', label: 'RESUME', enabled: true },
    { id: 'restart', label: 'RESTART STAGE', enabled: true },
    { id: 'options', label: 'OPTIONS', enabled: true },
    { id: 'quit-to-title', label: 'QUIT TO TITLE', enabled: true },
  ];
}

/** Mode select sub-menu items shown after Start. */
export function buildModeSelectMenuItems(): MenuItem[] {
  return [
    { id: 'mode-campaign', label: 'CAMPAIGN', enabled: true },
    { id: 'mode-boss-rush', label: 'BOSS RUSH', enabled: true },
    { id: 'mode-score-attack', label: 'SCORE ATTACK', enabled: true },
    { id: 'mode-survival', label: 'SURVIVAL', enabled: true },
    { id: 'mode-back', label: 'BACK', enabled: true },
  ];
}

/** Options sub-menu items. All enabled; complex flows (remap) show a stub. */
export function buildOptionsMenuItems(): MenuItem[] {
  return [
    { id: 'opt-master', label: 'MASTER VOL', enabled: true },
    { id: 'opt-mute', label: 'MUTE', enabled: true },
    { id: 'opt-music', label: 'MUSIC VOL', enabled: true },
    { id: 'opt-sfx', label: 'SFX VOL', enabled: true },
    { id: 'opt-voice', label: 'VOICE VOL', enabled: true },
    { id: 'opt-blood', label: 'BLOOD', enabled: true },
    { id: 'opt-shake', label: 'SCREEN SHAKE', enabled: true },
    { id: 'opt-language', label: 'LANGUAGE', enabled: true },
    { id: 'opt-key-remap', label: 'KEY REMAP', enabled: true },
    { id: 'opt-gamepad-remap', label: 'GAMEPAD REMAP', enabled: true },
    { id: 'opt-back', label: 'BACK', enabled: true },
  ];
}
